import { render, staticRenderFns } from "./SharedLessonsPage.vue?vue&type=template&id=6942b7bd&lang=pug&"
import script from "./SharedLessonsPage.vue?vue&type=script&lang=js&"
export * from "./SharedLessonsPage.vue?vue&type=script&lang=js&"
import style0 from "./SharedLessonsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports